import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ApproachingBuses from './ApproachingBuses';
import BusRoutes from './BusRoutes';
import { trackEvent } from '../utils/analytics';
import './StopDetailsTabs.css';

const StopDetailsTabs = ({ stopNumber }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('approaching');

  const handleTabChange = (tab) => {
    if (tab === activeTab) return;

    trackEvent('stop_tab_switched', {
      tab,
      stop_number: stopNumber
    });
    setActiveTab(tab);
  };

  return (
    <div className="stop-details-tabs">
      <div className="tabs-header">
        <button
          className={`tab-button ${activeTab === 'approaching' ? 'active' : ''}`}
          onClick={() => handleTabChange('approaching')}
        >
          <span className="tab-icon">📍</span>
          <span className="tab-label">{t('stopDetails.tabs.approaching')}</span>
        </button>
        <button
          className={`tab-button ${activeTab === 'routes' ? 'active' : ''}`}
          onClick={() => handleTabChange('routes')}
        >
          <span className="tab-icon">🚌</span>
          <span className="tab-label">{t('stopDetails.tabs.allRoutes')}</span>
        </button>
      </div>

      <div className="tabs-content">
        {activeTab === 'approaching' && <ApproachingBuses stopNumber={stopNumber} />}
        {activeTab === 'routes' && <BusRoutes stopNumber={stopNumber} />}
      </div>
    </div>
  );
};

export default StopDetailsTabs;
